'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode } from "inferno";
import { Adapter } from 'component-registry';
import { Component } from 'inferno';
import { interfaces } from 'isomorphic-schema';
import { IInputFieldWidget } from '../interfaces';
import { generateId } from './utils';
import { renderRows } from './ObjectFieldHelpers';

var ObjectFieldWidget = /*#__PURE__*/function (_Component) {
  _inherits(ObjectFieldWidget, _Component);

  function ObjectFieldWidget(props) {
    var _this;

    _classCallCheck(this, ObjectFieldWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ObjectFieldWidget).call(this, props));
    _this.isMounted = false;
    _this.didUpdate = _this.didUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.didInput = _this.didInput.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ObjectFieldWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Because this is a container we set isMounted here instead of getting it from parent
      this.isMounted = true;
    }
  }, {
    key: "didInput",
    value: function didInput(propName, data) {
      var newValue = _objectSpread({}, this.props.value);

      newValue[propName] = data;
      this.props.onInput && this.props.onInput(this.props.propName, newValue);
    }
  }, {
    key: "didUpdate",
    value: function didUpdate(propName, data) {
      var newValue = _objectSpread({}, this.props.value);

      newValue[propName] = data;
      this.props.onChange(this.props.propName, newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var field = this.props.adapter.context; // Should this really be field.interface?

      var schema = field._interface ? field._interface.schema : field._schema || field.schema;

      if (!schema) {
        return null;
      }

      return createVNode(1, "div", "InfernoFormlib-ObjectField", renderRows({
        schema: schema,
        namespace: this.props.namespace || [],
        inputName: this.props.inputName,
        value: this.props.value,
        selectFields: typeof this.props.selectFields === 'string' ? this.props.selectFields.split(',').map(function (k) {
          return k.trim();
        }) : this.props.selectFields,
        omitFields: typeof this.props.omitFields === 'string' ? this.props.omitFields.split(',').map(function (k) {
          return k.trim();
        }) : this.props.omitFields,
        lang: this.props.options && this.props.options.lang,
        validationErrors: this.props.validationError,
        isMounted: this.isMounted,
        customWidgets: this.props.customWidgets,
        onInput: this.didInput,
        onChange: this.didUpdate
      }), 0, {
        "id": generateId(this.props.namespace, '__Field')
      });
    }
  }]);

  return ObjectFieldWidget;
}(Component);

export { ObjectFieldWidget as default };
new Adapter({
  implements: IInputFieldWidget,
  adapts: interfaces.IObjectField,
  Component: ObjectFieldWidget
});